import(/* webpackMode: "eager" */ "/vercel/path0/app/[lang]/error.tsx");
